// src/App.tsx
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { useThemeStore } from './stores/themeStore';
import Layout from './components/layout/Layout';
import DevPasswordGate from './components/DevPasswordGate';

// Pages
import TopPage from './pages/TopPage';
import CharacterPage from './pages/CharacterPage';
import CharacterEditPage from './pages/CharacterEditPage';
import CharacterCreatePage from './pages/CharacterCreatePage';
import MyCharactersPage from './pages/MyCharactersPage';
import LoginPage from './pages/LoginPage';
import RoyaltyPage from './pages/RoyaltyPage';
import AdoptPage from './pages/AdoptPage';
import AdoptDetailPage from './pages/AdoptDetailPage';
import VTuberInvitePage from './pages/VTuberInvitePage';
import XOAuthCallbackPage from './pages/XOAuthCallbackPage';
import SettingsPage from './pages/SettingsPage';

// Theme provider component
const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isDarkMode } = useThemeStore();

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDarkMode]);

  return <>{children}</>;
};

function App() {
  return (
    <DevPasswordGate>
      <ThemeProvider>
        <AuthProvider>
          <Router>
            <Routes>
              {/* Pages with Layout (Header + Footer) */}
              <Route element={<Layout />}>
                <Route path="/" element={<TopPage />} />
                <Route path="/vtuber" element={<TopPage initialCategory="vtuber" />} />
                <Route path="/character/:characterId/edit" element={<CharacterEditPage />} />
                <Route path="/create" element={<CharacterCreatePage />} />
                <Route path="/my-characters" element={<MyCharactersPage />} />
                <Route path="/earnings" element={<RoyaltyPage />} />
                <Route path="/adopt" element={<AdoptPage />} />
                <Route path="/adopt/:characterId" element={<AdoptDetailPage />} />
                <Route path="/vtuber/invite" element={<VTuberInvitePage />} />
              </Route>

              {/* Pages without Layout (custom header) */}
              <Route path="/character/:characterId" element={<CharacterPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/auth/x/callback" element={<XOAuthCallbackPage />} />
            </Routes>
          </Router>
        </AuthProvider>
      </ThemeProvider>
    </DevPasswordGate>
  );
}

export default App;